import React from 'react';
import renderValue from '../../utility/renderValue';
import { FaArrowDownLong, FaChevronDown } from 'react-icons/fa6';
import classNames from 'classnames';

//specifically for rendering a diagram to show increase in value over time
export default function DiagramSection({ section, data }) {
  const { schema } = section || [];
  if (!schema?.length) return null;
  if (!data) return null;

  //check if the schema is the version without the potential values
  const simplifiedVersion = schema.length === 6;

  return (
    <div className="grid grid-cols-1 w-full h-full relative bg-primary-50">
      <h2 className=" w-full tracking-wider text-md font-medium text-primary mt-2 mb-2">
        <span className="px-3 py-1">{section.sectionLabel?.toUpperCase()}</span>
      </h2>
      <div className="rounded relative bg-white shadow-md">
        <div className="flex flex-col w-full justify-center  self-center items-center px-6 py-10 text-center">
          <div className="w-full h-full grid sm:grid-cols-5-diagram items-center justify-center relative pt-2 space-y-4 sm:space-y-0">
            <div className="flex flex-col items-center gap-1">
              <h3 className="text-base font-medium text-neutral-700 tracking-wide">
                {schema[1]?.label || ''}
              </h3>
              <span className="text-lg text-neutral-600">
                {renderValue(schema[1] || {}, data)}
              </span>
            </div>
            <div className="flex flex-col items-center gap-1">
              <h3 className="text-base font-semibold tracking-wide">
                {schema[0]?.label || ''}
              </h3>
              <span
                className={classNames(
                  'text-2xl',
                  Number(data[schema[5].name]) > 0
                    ? 'text-green-700'
                    : 'text-red-700'
                )}
              >
                {renderValue(schema[0] || {}, data)}
              </span>
            </div>
            <div className="flex sm:hidden flex-col-reverse items-center sm:col-span-2">
              <span className="text-lg text-neutral-600">
                {renderValue(schema[simplifiedVersion ? 4 : 5] || {}, data)}
              </span>
              <h3 className="text-base font-medium text-neutral-600 tracking-wide">
                {schema[simplifiedVersion ? 4 : 5]?.label || ''}
              </h3>
            </div>
            <div className="flex flex-col items-center gap-1 mt-[18px]">
              <h3 className="text-base font-medium">
                {schema[2]?.label || ''}
              </h3>
              <span className="aspect-1 w-12 h-12 bg-primary p-2 rounded-md flex flex-col items-center justify-center text-2xl font-medium text-white shadow">
                <span>{data[schema[2]?.name] || ''}</span>
                <span className="text-base -mt-1">{schema[2]?.unit || ''}</span>
              </span>
            </div>
            <div
              className={classNames(
                'flex flex-col items-center gap-1',
                simplifiedVersion && 'sm:col-span-2'
              )}
            >
              <h3 className="text-base font-semibold text-black tracking-wide">
                {schema[3]?.label || ''}
              </h3>
              <span className="text-2xl text-primary">
                {renderValue(schema[3] || {}, data)}
              </span>
            </div>

            <div className="flex sm:hidden flex-col-reverse items-center">
              <span className="text-lg text-green-700">
                {renderValue(schema[simplifiedVersion ? 5 : 6] || {}, data)}
              </span>
              <h3 className="text-base font-medium tracking-wide text-neutral-600">
                {schema[simplifiedVersion ? 5 : 6]?.label || ''}
              </h3>
            </div>

            {!simplifiedVersion && (
              <div className="flex flex-col items-center gap-1">
                <h3 className="text-base font-medium text-neutral-700 tracking-wide">
                  {schema[4]?.label || ''}
                </h3>
                <span className="text-lg text-neutral-600">
                  {renderValue(schema[4] || {}, data)}
                </span>
              </div>
            )}
          </div>
          <div className="hidden w-full h-full sm:grid sm:grid-cols-5-diagram items-center relative">
            <div className="sm:col-span-2 flex justify-center items center">
              <FaChevronDown className="text-2xl text-neutral-500" />
            </div>
            <div></div>
            <div
              className={classNames(
                'flex justify-center',
                simplifiedVersion && 'sm:col-span-2'
              )}
            >
              <FaArrowDownLong className="text-2xl text-neutral-500" />
            </div>
            <div className="flex justify-center">
              {!simplifiedVersion && (
                <FaArrowDownLong className="text-2xl text-neutral-500" />
              )}
            </div>
          </div>
          <div className="w-full h-full grid sm:grid-cols-5-diagram items-center pt-2 relative space-y-4 sm:space-y-0">
            <div className="hidden sm:flex sm:flex-col flex-col-reverse items-center sm:col-span-2">
              <span className="text-lg text-neutral-600">
                {renderValue(schema[simplifiedVersion ? 4 : 5] || {}, data)}
              </span>
              <h3 className="text-base font-medium text-neutral-600 tracking-wide">
                {schema[simplifiedVersion ? 4 : 5]?.label || ''}
              </h3>
            </div>
            <div className="hidden sm:block col-span-1"></div>
            <div
              className={classNames(
                'hidden sm:flex sm:flex-col flex-col-reverse items-center',
                simplifiedVersion && 'sm:col-span-2'
              )}
            >
              <span className="text-lg text-green-700">
                {renderValue(schema[simplifiedVersion ? 5 : 6] || {}, data)}
              </span>
              <h3 className="text-base font-medium tracking-wide text-neutral-600">
                {schema[simplifiedVersion ? 5 : 6]?.label || ''}
              </h3>
            </div>
            {!simplifiedVersion && (
              <div className="flex sm:flex-col flex-col-reverse items-center">
                <span className="text-lg text-neutral-600">
                  {renderValue(schema[7] || {}, data)}
                </span>
                <h3 className="text-base font-medium tracking-wide text-neutral-600">
                  {schema[7]?.label || ''}
                </h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
